import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import AnimateOnChange from 'react-animate-on-change';

export default class Ingredient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      hovered: false
    };
  }

  render() {
    const herb = this.props.herb;
    return (
      <div className="ingredients" onClick={ this.handleClick }>
        <h2>
          { herb.name }
          <AnimateOnChange
            baseClassName="ingredients-arrow"
            animationClassName="arrow-rotate"
            animate={ this.state.selected || this.state.hovered }
          >
            <div className="arrow" />
          </AnimateOnChange>
        </h2>
        <h3>{ herb.sciName }</h3>
        <p className="description">{ herb.description }</p>
        <AnimateOnChange
          baseClassName="display-image"
          animationClassName="display-image-enlarged"
          animate={ this.state.selected || this.state.hovered }
        >
          <img src={ herb.image } key={ herb.image } alt={ `Picture of a ${ herb.name } plant` } />
        </AnimateOnChange>
        <ReactCSSTransitionGroup
          transitionName="description"
          transitionEnterTimeout={ 400 }
          transitionLeaveTimeout={ 400 }
         >
           { this.state.selected || this.state.hovered ? <AdditionalInfo herb={ herb } /> : null }
         </ReactCSSTransitionGroup>
      </div>
    )
  }

  handleClick = () => {
    this.setState((prevS, props) => {
      return { selected: !prevS.selected }
    });
  };

  handleMouseEnter = () => {
    this.setState((prevS, props) => {
      return { hovered: true }
    });
  };

  handleMouseLeave = () => {
    this.setState((prevS, props) => {
      return { hovered: false }
    });
  };
}

const AdditionalInfo = (props) => {
  const classes = `additional-info`;
  return (
    <div key={ props.herb.name } className={ classes }>
      <p>{ props.herb.properties }</p>

    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Ingredient.jsx
 **/